import React from 'react'
import { useTranslation } from 'react-i18next'

interface CartPageLayoutProps {
  headerExtra?: React.ReactNode
  lines: React.ReactNode
  sidebar: React.ReactNode
  belowLines?: React.ReactNode
}

const CartPageLayout: React.FC<CartPageLayoutProps> = ({ headerExtra, lines, sidebar, belowLines }) => {
  const { t } = useTranslation()
  return (
    <div
      className='px-10 sm:px-20 flex flex-col md:flex-row justify-center mx-auto max-w-[1400px]'
      style={{ minHeight: 'inherit' }}
    >
      <div className='w-full'>
        <div className='flex items-center justify-between flex-wrap m-20 sm:mx-0'>
          <h1 className='font-bold text-2xl mr-12' style={{ lineHeight: '36px' }}>
            {t('title.shoppingBag', 'Shopping Bag')}
          </h1>
          {headerExtra}
        </div>
        <div className='flex flex-col md:flex-row'>
          <div className={`flex-1 ${sidebar ? 'md:w-900 md:mr-20' : 'w-full'}`}>
            {lines}
            {belowLines}
          </div>
          {sidebar && <div className='w-full md:w-400 flex flex-col'>{sidebar}</div>}
        </div>
      </div>
    </div>
  )
}

export default CartPageLayout
